/**
 * @module getThemeDefinitions
 */
import getClientConfigurationFromStore from './getClientConfigurationFromStore';
import { Theme } from 'owa-actionable-message-v2';

/**
 * @function
 * To get the theme json url mappings
 * @param { boolean } [isDarkMode = false] - Is Dark mode enabled. false by default.
 * @returns { [index: string]: Theme } Theme json url mappings.
 */
const getThemeDefinitions = (isDarkMode: boolean = false): { [index: string]: Theme } => {
    const cache = getClientConfigurationFromStore();
    let themeUrlMappings: { [key: string]: string };
    if (isDarkMode) {
        themeUrlMappings = cache?.data?.themeMappingsDarkMode?.connectors;
    } else {
        themeUrlMappings = cache?.data?.themeMappings?.connectors;
    }

    if (themeUrlMappings) {
        const themes: { [index: string]: Theme } = {};
        Object.keys(themeUrlMappings).forEach((key: string) => {
            const theme = {
                themeConfigUrl: themeUrlMappings[key],
                hostConfig: null,
                stylesheetUrl: null,
                isResolved: false,
            };
            themes[key] = theme;
        });
        return themes;
    }

    return null;
};

export default getThemeDefinitions;
